// extracted by mini-css-extract-plugin
export default {"learningTitle":"LearningCenter_learningTitle__xfkmc","mainLearning":"LearningCenter_mainLearning__5KIyX","learningCards":"LearningCenter_learningCards__zTb98"};